// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"19ab94cc","726":"20e4786b","896":"a650d2b8"}[chunkId] + ".chunk.js";
};